import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MaterialSwitch from '@material-ui/core/Switch';
import { FormControlLabel } from '@material-ui/core';
import PopUp from 'components/Operational/PopUp/PopUp';
import styles from './index.module.scss';
import cn from 'classnames';
import checkImage from 'images/icon_switch_on.svg';
import uncheckImage from 'images/icon_switch_off.svg';
import Tooltip, { InfoPropTypes } from 'components/Tooltip';
import { GEOGRAPHICAL_MAP } from 'utils/constants/Map';
import { useTranslation } from 'react-i18next';

const Switch = ({
  label,
  checked = false,
  onChange,
  setFieldValue,
  value = false,
  name,
  classes,
  className,
  popUpRequired,
  title = '',
  info,
  hidden,
  disabled = false,
  labelPosition = 'start',
  compact,
  setFormikFieldValues,
  popupMessagefields,
  formtype,
}) => {
  const { t } = useTranslation();
  const [popupCheck, setPopupCheck] = useState(true);
  const submitBtnHandler = e => {
    e.preventDefault();
    switch (name) {
      case 'newSite': {
        if (popUpRequired && formtype === 'task') {
          const keyValuePairs = {
            newSite: true,
            siteSurfaceImages: GEOGRAPHICAL_MAP,
            location: [],
            additionalMarkers: undefined,
            site: undefined,
          };
          setFormikFieldValues(keyValuePairs);
          setPopupCheck(true);
        }

        if (popUpRequired && formtype === 'patrolDef') {
          const keyValuePairs = {
            newSite: true,
            siteSurfaceImages: GEOGRAPHICAL_MAP,
            checkpoints: [],
            checkPointDetail: undefined,
            site: undefined,
          };
          setFormikFieldValues(keyValuePairs);
          setPopupCheck(true);
        }
        break;
      }

      default: {
        setFieldValue(true);
        setPopupCheck(true);
        break;
      }
    }
  };

  const closePopupHandler = e => {
    e.preventDefault();
    switch (name) {
      case 'newSite': {
        if (popUpRequired && formtype === 'task') {
          const keyValuePairs = {
            newSite: false,
          };
          setFormikFieldValues(keyValuePairs);
        }
        if (popUpRequired && formtype === 'patrolDef') {
          const keyValuePairs = {
            newSite: false,
          };
          setFormikFieldValues(keyValuePairs);
        }
        break;
      }

      default: {
        setFieldValue(false);
        setPopupCheck(false);
        break;
      }
    }
  };
  return (
    <>
      <div
        className={cn(styles.switch, className, {
          [styles.hidden]: hidden,
          [styles.compact]: compact,
        })}
      >
        <FormControlLabel
          control={
            <MaterialSwitch
              title={t(title)}
              checked={checked}
              onChange={onChange}
              value={value}
              color="primary"
              disabled={disabled}
              classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
                disabled: classes.disabled,
              }}
              inputProps={{ name: name }}
            />
          }
          label={
            <>
              <span
                className={cn(styles.labelText, classes.labelColor, className)}
              >
                {t(label)}
              </span>
              {info && <Tooltip text={info} />}
            </>
          }
          labelPlacement={labelPosition}
          classes={{
            labelPlacementStart: classes.labelStart,
            labelPlacementTop: classes.labelTop,
          }}
        />
      </div>

      {popUpRequired &&
      popupCheck && ( // check the condition on which i need to show the popup, -> that requires the assigned asset value
          <PopUp
            title={
              popupMessagefields ? popupMessagefields.title : 'Confirmation'
            }
            statusMessage={
              popupMessagefields
                ? popupMessagefields.statusMessage
                : 'It is in use.'
            }
            actionMessage={
              popupMessagefields
                ? popupMessagefields.actionMessage
                : 'Do you wish to continue?'
            }
            submitBtnText={
              popupMessagefields ? popupMessagefields.submitBtnText : 'yes'
            }
            submit={submitBtnHandler}
            cancelBtnText={
              popupMessagefields ? popupMessagefields.cancelBtnText : 'No'
            }
            cancel={closePopupHandler}
            close={closePopupHandler}
          />
        )}
    </>
  );
};

const CustomSwitch = withStyles(theme => ({
  root: {
    width: 42,
    height: 22,
    padding: 0,
    marginLeft: '0.5rem',
    paddingBottom: '2px',
  },
  switchBase: {
    padding: 1,
    top: 0,
    left: 0,

    '&$checked': {
      transform: 'translateX(21px)',
      color: 'white',

      opacity: props => {
        if (props.disabled) {
          return 0.5;
        } else {
          return 1;
        }
      },
      '& + $track': {
        backgroundColor: theme.palette.primary.main,
        opacity: props => {
          if (props.disabled) {
            return 0.5;
          } else {
            return 1;
          }
        },
      },
      '& $thumb': {
        backgroundImage: `url(${checkImage})`,
      },
    },
    '&$disabled': {
      opacity: 0.5,
    },
  },
  thumb: {
    width: 20,
    height: 20,
    boxShadow: 'none',
    backgroundImage: `url(${uncheckImage})`,
    '&::before': {
      content: '',
      display: 'block',
      height: '100%',
      position: 'absolute',
      width: '100%',
    },
  },
  track: {
    borderRadius: 13,
    border: '1px solid #939598',
  },
  checked: {},
  focusVisible: {},
  labelStart: {
    marginLeft: 0,
    marginRight: 5,
    // color: theme.palette.secondary.main,
  },
  labelTop: {
    alignItems: 'flex-start',
    '& .MuiFormControlLabel-label': {
      marginBottom: '8px',
    },
    '& .MuiSwitch-root': {
      marginLeft: 0,
    },
  },
  labelColor: {
    color: props => {
      if (props.disabled) {
        return theme.palette.text.disabled;
      } else {
        return theme.palette.text.secondary;
      }
    },
  },
  disabled: {},
}))(Switch);

Switch.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  name: PropTypes.string,
  className: PropTypes.string,
  setFieldValue: PropTypes.func,
  popUpRequired: PropTypes.bool,
  title: PropTypes.string,
  info: InfoPropTypes,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  labelPosition: PropTypes.oneOf(['top', 'bottom', 'start', 'end']),
  compact: PropTypes.bool,
  setFormikFieldValues: PropTypes.func,
  popupMessagefields: PropTypes.object,
  formtype: PropTypes.string,
};

export default CustomSwitch;
